import {  useDispatch, useSelector } from "react-redux"
import { Field, Input, Label } from "../../styles/common"
import { ComponentUpdate, toggleRefreshColor } from "../../store/slices/component"
import { useState } from "react";
import Swal from "sweetalert2";
import { ProductSizeAdded } from "../../common/CommonApi";
import { X } from "lucide-react";
import {
  CloseButton,
  HelperText,
  PrimaryButton,
  SecondaryButton,
  SetupBody,
  SetupDialog,
  SetupFooter,
  SetupHeader,
  SetupOverlay
} from "./ProductSetupModal";

export const AddSize = () => {
    const loginData = useSelector((state) => state.auth)
    const dispatch = useDispatch()
    const [form, setForm] = useState({
        size: '',
      });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        let bodyData = {
             size:form.size,
            _id:loginData._id
        }

        let response = await ProductSizeAdded(bodyData)
          if (response.data.message === "SUCCESSFULLY_UPDATED") {
            Swal.fire('Size Added.')
            dispatch(toggleRefreshColor());
            dispatch(ComponentUpdate({isSize:false,isProductModelOpen:true}))
          }
      } catch (err) {
        console.error("Error:", err);
      }
    };

      const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setForm((prevForm) => ({
        ...prevForm,
        [name]:
            type === "checkbox"
            ? checked
            : type === "file"
                ? files[0]   // 👈 will store in form.categoryImage
                : name === "sortOrder"
                ? Number(value)
                : value,
        }));
    };

    const closeModal = () => dispatch(ComponentUpdate({isSize:false}));

    return (
        <SetupOverlay onClick={closeModal}>
            <SetupDialog onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
                <SetupHeader>
                    <div>
                      <h2>Add Size</h2>
                      <p>Add a reusable size option for product variants.</p>
                    </div>
                    <CloseButton type="button" aria-label="Close add size" onClick={closeModal}>
                      <X size={18} />
                    </CloseButton>
                </SetupHeader>
                <SetupBody>
                <Field>
                    <Label>Size</Label>
                    <Input name="size"
                    value={form.size} 
                    onChange={handleChange} 
                    required
                    />
                    <HelperText>Example: S, M, L, XL, 42, or Free Size.</HelperText>
                </Field>
                </SetupBody>
                <SetupFooter>
                  <SecondaryButton type="button" onClick={closeModal}>Cancel</SecondaryButton>
                  <PrimaryButton type="submit">Add Size</PrimaryButton>
                </SetupFooter>
            </SetupDialog>
        </SetupOverlay>
    )
}
